export default {"src":"/_next/static/media/icon-industrialLand.e789c91c.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};